/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VirtualMachineAgentsListRequest {
    getFixupPrototypeFunction() { return VirtualMachineAgentsListRequest.fixupPrototype; }

    static newInstance(model: Partial<VirtualMachineAgentsListRequest>): VirtualMachineAgentsListRequest {
        let obj = Object.assign(new VirtualMachineAgentsListRequest(), model);
        VirtualMachineAgentsListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VirtualMachineAgentsListRequest>): VirtualMachineAgentsListRequest {
        if (!model) return null;
        return VirtualMachineAgentsListRequest.newInstance(<VirtualMachineAgentsListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VirtualMachineAgentsListRequest) {
        if (!obj) return;

        models.VirtualMachineAgentsListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VirtualMachineAgentsListRequest): boolean {
        Object.setPrototypeOf(obj, VirtualMachineAgentsListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.VirtualMachineAgentsFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.VirtualMachineAgentsSummarySortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.VirtualMachineAgentsSummarySortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.VirtualMachineAgentsFilter;

}
